import React from "react";
import { Route, Switch } from "react-router-dom";
import LazyLoad from "../../components/Common/LazyLoad";
import IrShell from "./shell/IrShell";
import "./theme/ir-theme.scss";

// Mini-router for the Incident Response module, wrapped in the stable five-area shell.
// Playbooks, Sessions, Reports, Dashboard and Administration are functional.
const ScenarioPicker = LazyLoad(() => import("./ScenarioPicker/component"));
const Administration = LazyLoad(() => import("./Administration/component"));
const GuidedRouting = LazyLoad(() => import("./GuidedRouting/component"));
const ModeFork = LazyLoad(() => import("./ModeFork/component"));
const First60Gate = LazyLoad(() => import("./First60Gate/component"));
const PlaybookView = LazyLoad(() => import("./PlaybookView/component"));
const SessionsList = LazyLoad(() => import("./Sessions/component"));
const ReportsPage = LazyLoad(() => import("./reports/ReportsPage"));
const DashboardPage = LazyLoad(() => import("./Dashboard/component"));

const IncidentResponseLayout = () => {
  return (
    <div className="ir-module">
      <IrShell>
        <Switch>
          {/* Areas */}
          <Route exact path="/playbooks" component={ScenarioPicker} />
          <Route exact path="/playbooks/sessions" component={SessionsList} />
          <Route exact path="/playbooks/dashboard" component={DashboardPage} />
          <Route exact path="/playbooks/reports" component={ReportsPage} />
          <Route
            exact
            path="/playbooks/administration"
            component={Administration}
          />

          {/* Playbooks-area sub-flows */}
          <Route exact path="/playbooks/route" component={GuidedRouting} />
          <Route
            exact
            path="/playbooks/scenario/:id/gate"
            component={First60Gate}
          />
          <Route exact path="/playbooks/scenario/:id" component={ModeFork} />

          {/* Execution — a persisted session */}
          <Route exact path="/playbooks/run/:sessionId" component={PlaybookView} />
        </Switch>
      </IrShell>
    </div>
  );
};

export default IncidentResponseLayout;
